import { createContext } from 'react'
import createStateContext from './utils/createStateContext'

// App-wide Contexts
export const FlashMessageContext = createContext()

export const orderedStepsContext = createStateContext()
